//#region src/workspace/user-workspace-roles-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.workspaceAdmin = "role_admin", e.workspaceAssistant = "role_assistant", e;
}({});
//#endregion
export { e as UserWorkspaceRolesEnum };
